export default ['api', function (api) {
    return {
        getAllEvents: () => {
            return api.get(`api/events`).then(response => response.data);
        }
    };
}];



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/page/services/event.service.js